import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "quotewizard" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", {
  class: "subtitle",
  style: {"text-align":"center"}
}, " Review Your Purchase ", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_5 = { class: "reviewleft" }
const _hoisted_6 = { class: "reviewtable" }
const _hoisted_7 = {
  width: "100%",
  border: "0",
  cellspacing: "0",
  cellpadding: "0"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("td", { valign: "top" }, "Policy Term", -1)
const _hoisted_9 = { valign: "top" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("td", {
  valign: "top",
  width: "55%"
}, "Coverage Start Date", -1)
const _hoisted_11 = { valign: "top" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("td", { valign: "top" }, "Your liability", -1)
const _hoisted_13 = { valign: "top" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("td", { valign: "top" }, "Personal Property Coverage", -1)
const _hoisted_15 = { valign: "top" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("td", { valign: "top" }, "Deductible", -1)
const _hoisted_17 = { valign: "top" }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("td", { valign: "top" }, "Hurricane Deductible", -1)
const _hoisted_20 = { valign: "top" }
const _hoisted_21 = { key: 1 }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("td", { valign: "top" }, "Replacement Cost", -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("td", { valign: "top" }, "Included", -1)
const _hoisted_24 = [
  _hoisted_22,
  _hoisted_23
]
const _hoisted_25 = { key: 2 }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("td", { valign: "top" }, "Water / Sewer Backup", -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("td", { valign: "top" }, "Added", -1)
const _hoisted_28 = [
  _hoisted_26,
  _hoisted_27
]
const _hoisted_29 = { key: 3 }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("td", { valign: "top" }, "Fraud Expense Protection", -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("td", { valign: "top" }, "Added", -1)
const _hoisted_32 = [
  _hoisted_30,
  _hoisted_31
]
const _hoisted_33 = { key: 4 }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("td", { valign: "top" }, "Earthquake", -1)
const _hoisted_35 = /*#__PURE__*/_createElementVNode("td", { valign: "top" }, "Added", -1)
const _hoisted_36 = [
  _hoisted_34,
  _hoisted_35
]
const _hoisted_37 = /*#__PURE__*/_createElementVNode("td", { valign: "top" }, "Payment Plan", -1)
const _hoisted_38 = { valign: "top" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("td", { valign: "top" }, "Accidental Damage Personal Property Add-On", -1)
const _hoisted_40 = { valign: "top" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("td", { valign: "top" }, " Accidental Damage Personal Property Coverage ", -1)
const _hoisted_42 = { valign: "top" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("td", { valign: "top" }, " Accidental Damage Personal Property Deductible ", -1)
const _hoisted_44 = { valign: "top" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("td", { valign: "top" }, " Accidental Damage Personal Property Payment Plan ", -1)
const _hoisted_46 = { valign: "top" }
const _hoisted_47 = { class: "reviewtable" }
const _hoisted_48 = {
  width: "100%",
  border: "0",
  cellspacing: "0",
  cellpadding: "0",
  class: "collapserowmobile"
}
const _hoisted_49 = /*#__PURE__*/_createElementVNode("td", {
  valign: "top",
  width: "55%"
}, "Policyholder", -1)
const _hoisted_50 = { valign: "top" }
const _hoisted_51 = /*#__PURE__*/_createElementVNode("td", { valign: "top" }, "Date of Birth", -1)
const _hoisted_52 = { valign: "top" }
const _hoisted_53 = /*#__PURE__*/_createElementVNode("td", { valign: "top" }, "Phone Number", -1)
const _hoisted_54 = { valign: "top" }
const _hoisted_55 = /*#__PURE__*/_createElementVNode("td", { valign: "top" }, "Email", -1)
const _hoisted_56 = { valign: "top" }
const _hoisted_57 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_58 = {
  width: "100%",
  border: "0",
  cellspacing: "0",
  cellpadding: "0"
}
const _hoisted_59 = /*#__PURE__*/_createElementVNode("tr", null, null, -1)
const _hoisted_60 = /*#__PURE__*/_createElementVNode("td", {
  valign: "top",
  width: "55%"
}, "Roommate(s)", -1)
const _hoisted_61 = { valign: "top" }
const _hoisted_62 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_63 = { key: 0 }
const _hoisted_64 = /*#__PURE__*/_createElementVNode("td", { valign: "top" }, "Interested Party", -1)
const _hoisted_65 = { valign: "top" }
const _hoisted_66 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_67 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_68 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_69 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_70 = {
  width: "100%",
  border: "0",
  cellspacing: "0",
  cellpadding: "0"
}
const _hoisted_71 = /*#__PURE__*/_createElementVNode("td", {
  valign: "top",
  width: "55%"
}, "Property Address", -1)
const _hoisted_72 = { valign: "top" }
const _hoisted_73 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_74 = /*#__PURE__*/_createElementVNode("td", { valign: "top" }, "Mailing Address", -1)
const _hoisted_75 = { valign: "top" }
const _hoisted_76 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_77 = /*#__PURE__*/_createElementVNode("td", { valign: "top" }, "School Information", -1)
const _hoisted_78 = { valign: "top" }
const _hoisted_79 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_80 = { class: "reviewright" }
const _hoisted_81 = { class: "reviewtable" }
const _hoisted_82 = {
  width: "100%",
  border: "0",
  cellspacing: "0",
  cellpadding: "0"
}
const _hoisted_83 = /*#__PURE__*/_createElementVNode("td", {
  valign: "top",
  width: "55%"
}, "Payment Type", -1)
const _hoisted_84 = { valign: "top" }
const _hoisted_85 = { key: 0 }
const _hoisted_86 = /*#__PURE__*/_createElementVNode("td", { valign: "top" }, "Card Details", -1)
const _hoisted_87 = { valign: "top" }
const _hoisted_88 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_89 = {
  width: "100%",
  border: "0",
  cellspacing: "0",
  cellpadding: "0"
}
const _hoisted_90 = /*#__PURE__*/_createElementVNode("td", {
  valign: "top",
  width: "55%"
}, "Billing Address", -1)
const _hoisted_91 = { valign: "top" }
const _hoisted_92 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_93 = { class: "reviewtable" }
const _hoisted_94 = /*#__PURE__*/_createElementVNode("h4", null, "Total", -1)
const _hoisted_95 = {
  width: "100%",
  border: "0",
  cellspacing: "0",
  cellpadding: "0"
}
const _hoisted_96 = {
  valign: "top",
  width: "80%"
}
const _hoisted_97 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_98 = {
  key: 0,
  style: {"font-size":"12px"}
}
const _hoisted_99 = { valign: "top" }
const _hoisted_100 = { valign: "top" }
const _hoisted_101 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_102 = {
  key: 0,
  style: {"font-size":"12px"}
}
const _hoisted_103 = { valign: "top" }
const _hoisted_104 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_105 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_106 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_107 = {
  width: "100%",
  border: "0",
  cellspacing: "0",
  cellpadding: "0"
}
const _hoisted_108 = /*#__PURE__*/_createElementVNode("td", { valign: "top" }, [
  /*#__PURE__*/_createTextVNode(" Due Today"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br")
], -1)
const _hoisted_109 = { valign: "top" }
const _hoisted_110 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_111 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_112 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_113 = /*#__PURE__*/_createElementVNode("p", { style: {"font-size":"13px","line-height":"20px"} }, " NSSI Accidental Damage Add-on Waiting Period: There is a 30 day waiting period for personal property claims resulting from accidental damage. Damages that occur within this waiting period will not be covered. ", -1)
const _hoisted_114 = /*#__PURE__*/_createElementVNode("p", { style: {"font-size":"13px","line-height":"20px"} }, " PAYMENTS: You understand that your account will be charged automatically monthly, 4-pay or annually based on the “Payment Option” you selected. ", -1)
const _hoisted_115 = /*#__PURE__*/_createElementVNode("p", { style: {"font-size":"13px","line-height":"20px"} }, " Fraud Notice: Any person who, with intent to defraud or knowing that he is facilitating a fraud against an insurer, submits an application or files a claim containing a false or deceptive statement is guilty of insurance fraud. ", -1)
const _hoisted_116 = { style: {"font-size":"13px","line-height":"20px"} }
const _hoisted_117 = /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1)
const _hoisted_118 = { style: {"text-align":"center"} }
const _hoisted_119 = ["disabled"]
const _hoisted_120 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_121 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_122 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_123 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

import { LocalDate, DateTimeFormatter } from "@js-joda/core";
import { PaymentOptions } from "@/models/QuoteInsurance";
import {
  maskedCardNumber,
  billingDayWithOrdinal,
  formatAmount,
  calculateQuoteTotal,
} from "@/utils/Utils";
import DisclosuresModal from "@/views/modals/context/DisclosuresModal.vue";
import PaymentAuthorizationModal from "@/views/modals/context/PaymentAuthorizationModal.vue";
import { NssiData } from "@/api/NssiData";
import Loader from "@/components/MainLoader.vue";
import { Defaults } from "@/models/Defaults";
import { UserData } from "@/api/UserData";
import { AssurantData } from "@/api/AssurantData";
import {
  rentersNextPaymentDateFormated,
  nssiNextPaymentDateFormated,
  formatAmountWithoutCents,
} from "@/utils/Utils";
import { watch } from "vue";
import { ref, computed, ComputedRef } from "vue";
import { useQuoteStore } from "@/stores/root/quote";
import { useUserStore } from "@/stores/root/users";
import BaseModal from "@/views/modals/BaseModal.vue";
import Modals from "@/utils/Modals";
import useModal from "@/hooks/useModal";

const title = "Review";

export default /*#__PURE__*/_defineComponent({
  __name: 'QuoteReview',
  setup(__props) {

const { toggleModal } = useModal();

const loading = ref(false);
const issuingPolicies = ref(false);
const refName = ref(null);
const disclosuresModal = ref(null);
const paymentAuthorizationModal = ref(null);
const quote = useQuoteStore();
const userStore = useUserStore();
const user = userStore.user;

watch(user, (current) => {
  if (!current.loggedIn) {
    quote.setQuoteStep("quote-account");
  }
});

async function goToPage(command: string) {
  // Re-submit protection
  if (issuingPolicies.value) {
    return;
  }

  loading.value = true;
  issuingPolicies.value = true;
  try {
    //await UserData.fetchUser(); //TODO is this needed?
    if (quote.rentersInsurance && !quote.assurantPassed) {
      const result = await AssurantData.issuePolicy(quote);
      if (result.error) {
        quote.assurantPassed = false;
        quote.assurantPolicyError = result.message;
        issuingPolicies.value = false;
        quote.setQuoteStep("quote-done-assurant-failed-api");
        return;
      } else {
        quote.assurantPassed = true;
        quote.rentersInsurance.policyNumber =
          result.result.transactionDetails.policyId;
        quote.assurantPolicyError = "";
      }
    }
    if (quote.personalInsurance && !quote.nssiPassed) {
      const cartId = await NssiData.toRemote(quote);
      const userDataAll = await NssiData.getUserData();
      const result = await NssiData.issuePolicy(quote, userDataAll, cartId);
      if (result.error) {
        quote.nssiPassed = false;
        quote.nssiPolicyError = result.message;
        //saveStorage();
      } else {
        quote.nssiPassed = true;
        quote.personalInsurance.transactionId = result.policy;
        //quote.personalInsurance.transactionId = result.policy.PolicyID;
        //quote.personalInsurance.policyNumber = result.policy.PolicyNumber;
        quote.nssiPolicyError = "";
      }
    }
  } catch (error) {
    console.log("err on Assurant or NSSI API");
    //TODO
  }
  issuingPolicies.value = false;
  let nssiCheckFlag = true;
  if (quote.personalInsurance && !quote.nssiPassed) {
    nssiCheckFlag = false;
  }
  if (quote.assurantPassed && nssiCheckFlag) {
    loading.value = false;
    quote.setQuoteStep(command);
  }
}

const rentersNextPaymentDate = computed(() => {
  return rentersNextPaymentDateFormated(quote);
});
const nssiNextPaymentDate = computed(() => {
  return nssiNextPaymentDateFormated(quote);
});

const quoteCoverage = async () => {
  quote.setQuoteStep("quote-quote");
};

function quoteCheckoutPayment() {
  quote.setQuoteStep("quote-checkout-payment");
}

function quoteCheckout() {
  quote.setQuoteStep("quote-checkout");
}

function formatDate(value: string) {
  if (value) {
    return LocalDate.parse(value).format(
      DateTimeFormatter.ofPattern("M/d/yyyy")
    );
  }
}

// function formatAmountWithoutCents(value: number): string {
//   return formatAmountWithoutCents(value);
// }

// function formatAmount(value: number): string {
//   return formatAmount(value);
// }

function formatPaymentOption(value: any) {
  const num = Number(value) as PaymentOptions;
  switch (num) {
    case PaymentOptions.Monthly:
      return "Monthly";
    case PaymentOptions.Annual:
      return "Annual";
    case PaymentOptions.FourPay:
      return "4 Pay";
    default:
      return "Unknown";
  }
}

function formatCardNumber(cardNumber: string): string {
  return maskedCardNumber(cardNumber);
}

function formatBillingDay(billingDay: number): string {
  return billingDayWithOrdinal(billingDay);
}

function showDisclosuresModal() {
  toggleModal(Modals.DISCLOSURES_MODAL.label);
}

function showPaymentAuthorizationModal() {
  toggleModal(Modals.PAYMENT_AUTHORIZATION_MODAL.label);
}

const processingFee: ComputedRef<number> = computed(() => {
  return quote.personalInsurance.paymentOption == PaymentOptions.Monthly
    ? quote.monthlyProcessingFee
    : quote.processingFee;
});

const quoteTotal: ComputedRef<number> = computed(() => {
  return calculateQuoteTotal(quote);
});

function formatPhoneNumber(phoneNumberString: string) {
  const cleaned = ("" + phoneNumberString).replace(/\D/g, "");
  const match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    const intlCode = match[1] ? "+1 " : "";
    return [intlCode, "(", match[2], ") ", match[3], "-", match[4]].join("");
  }
  return null;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(Loader, { loading: loading.value }, null, 8, ["loading"]),
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("h4", null, [
            _createTextVNode(" Your Coverage Details "),
            _createElementVNode("a", {
              href: "",
              class: "edit",
              onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (quoteCoverage()), ["prevent"]))
            }, "Edit")
          ]),
          _createElementVNode("table", _hoisted_7, [
            _createElementVNode("tbody", null, [
              _createElementVNode("tr", null, [
                _hoisted_8,
                _createElementVNode("td", _hoisted_9, _toDisplayString(_unref(quote).info.policyLength) + " Year", 1)
              ]),
              _createElementVNode("tr", null, [
                _hoisted_10,
                _createElementVNode("td", _hoisted_11, _toDisplayString(formatDate(_unref(quote).info.coverageStartDate)), 1)
              ]),
              _createElementVNode("tr", null, [
                _hoisted_12,
                _createElementVNode("td", _hoisted_13, _toDisplayString(_unref(formatAmountWithoutCents)(
                      _unref(quote).rentersInsurance.quoteCoverageDetails
                        .liabilityAmount
                    )), 1)
              ]),
              _createElementVNode("tr", null, [
                _hoisted_14,
                _createElementVNode("td", _hoisted_15, _toDisplayString(_unref(formatAmountWithoutCents)(
                      _unref(quote).rentersInsurance.quoteCoverageDetails
                        .personalPropertyAmount
                    )), 1)
              ]),
              _createElementVNode("tr", null, [
                _hoisted_16,
                _createElementVNode("td", _hoisted_17, _toDisplayString(_unref(formatAmountWithoutCents)(
                      _unref(quote).rentersInsurance.quoteCoverageDetails.deductible
                    )), 1)
              ]),
              (_unref(quote).rentersInsurance.quoteCoverageDetails.hurricaneDeductible != null)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_18, [
                    _hoisted_19,
                    _createElementVNode("td", _hoisted_20, _toDisplayString(_unref(formatAmountWithoutCents)(
                      _unref(quote).rentersInsurance.quoteCoverageDetails
                        .hurricaneDeductible
                    )), 1)
                  ]))
                : _createCommentVNode("", true),
              (_unref(quote).rentersInsurance.quoteCoverageDetails.replacementCost)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_21, _hoisted_24))
                : _createCommentVNode("", true),
              (_unref(quote).rentersInsurance.quoteCoverageDetails.waterBackup)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_25, _hoisted_28))
                : _createCommentVNode("", true),
              (_unref(quote).rentersInsurance.quoteCoverageDetails.identityFraud)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_29, _hoisted_32))
                : _createCommentVNode("", true),
              (_unref(quote).rentersInsurance.quoteCoverageDetails.earthquake)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_33, _hoisted_36))
                : _createCommentVNode("", true),
              _createElementVNode("tr", null, [
                _hoisted_37,
                _createElementVNode("td", _hoisted_38, _toDisplayString(formatPaymentOption(_unref(quote).rentersInsurance.paymentOption)), 1)
              ]),
              _createElementVNode("tr", null, [
                _hoisted_39,
                _createElementVNode("td", _hoisted_40, _toDisplayString(_unref(quote).hasPersonalInsurance ? "Added" : "N/A"), 1)
              ]),
              _createElementVNode("tr", null, [
                _hoisted_41,
                _createElementVNode("td", _hoisted_42, _toDisplayString(_unref(quote).hasPersonalInsurance
                      ? _unref(formatAmountWithoutCents)(
                          _unref(quote).personalInsurance.coverageAmount
                        )
                      : "N/A"), 1)
              ]),
              _createElementVNode("tr", null, [
                _hoisted_43,
                _createElementVNode("td", _hoisted_44, _toDisplayString(_unref(quote).hasPersonalInsurance
                      ? _unref(formatAmountWithoutCents)(
                          _unref(quote).personalInsurance.deductibleAmount
                        )
                      : "N/A"), 1)
              ]),
              _createElementVNode("tr", null, [
                _hoisted_45,
                _createElementVNode("td", _hoisted_46, _toDisplayString(formatPaymentOption(_unref(quote).rentersInsurance.paymentOption)), 1)
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_47, [
          _createElementVNode("h4", null, [
            _createTextVNode(" Your Information "),
            _createElementVNode("a", {
              href: "",
              class: "edit",
              onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (quoteCheckout()), ["prevent"]))
            }, "Edit")
          ]),
          _createElementVNode("table", _hoisted_48, [
            _createElementVNode("tbody", null, [
              _createElementVNode("tr", null, [
                _hoisted_49,
                _createElementVNode("td", _hoisted_50, _toDisplayString(_unref(quote).checkout.info.firstName) + " " + _toDisplayString(_unref(quote).checkout.info.lastName), 1)
              ]),
              _createElementVNode("tr", null, [
                _hoisted_51,
                _createElementVNode("td", _hoisted_52, _toDisplayString(formatDate(_unref(quote).checkout.info.dob)), 1)
              ]),
              _createElementVNode("tr", null, [
                _hoisted_53,
                _createElementVNode("td", _hoisted_54, _toDisplayString(formatPhoneNumber(_unref(quote).checkout.info.phone)), 1)
              ]),
              _createElementVNode("tr", null, [
                _hoisted_55,
                _createElementVNode("td", _hoisted_56, _toDisplayString(_unref(quote).checkout.info.email), 1)
              ])
            ])
          ]),
          _hoisted_57,
          _createElementVNode("table", _hoisted_58, [
            _createElementVNode("tbody", null, [
              _hoisted_59,
              _createElementVNode("tr", null, [
                _hoisted_60,
                _createElementVNode("td", _hoisted_61, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(quote).checkout.roommates, (roommate) => {
                    return (_openBlock(), _createElementBlock(_Fragment, {
                      key: 
                      'roommate-' + _unref(quote).checkout.roommates.indexOf(roommate)
                    
                    }, [
                      _createTextVNode(_toDisplayString(roommate.firstName) + " " + _toDisplayString(roommate.lastName), 1),
                      _hoisted_62
                    ], 64))
                  }), 128))
                ])
              ]),
              (_unref(quote).checkout.interestedParty.firstName !== '')
                ? (_openBlock(), _createElementBlock("tr", _hoisted_63, [
                    _hoisted_64,
                    _createElementVNode("td", _hoisted_65, [
                      _createTextVNode(_toDisplayString(_unref(quote).checkout.interestedParty.firstName +
                    " " +
                    _unref(quote).checkout.interestedParty.lastName), 1),
                      _hoisted_66,
                      _createTextVNode(" " + _toDisplayString(_unref(quote).checkout.interestedParty.address.address) + " " + _toDisplayString(_unref(quote).checkout.interestedParty.address.apt
                      ? ", Apt " + _unref(quote).checkout.interestedParty.address.apt
                      : ""), 1),
                      _hoisted_67,
                      _createTextVNode(" " + _toDisplayString(_unref(quote).checkout.interestedParty.address.city) + ", " + _toDisplayString(_unref(quote).checkout.interestedParty.address.state.title) + " " + _toDisplayString(_unref(quote).checkout.interestedParty.address.zip), 1),
                      _hoisted_68
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _hoisted_69,
          _createElementVNode("table", _hoisted_70, [
            _createElementVNode("tbody", null, [
              _createElementVNode("tr", null, [
                _hoisted_71,
                _createElementVNode("td", _hoisted_72, [
                  _createTextVNode(_toDisplayString(_unref(quote).address.address), 1),
                  _hoisted_73,
                  _createTextVNode(" " + _toDisplayString(_unref(quote).address.city) + ", " + _toDisplayString(_unref(quote).address.state.title) + " " + _toDisplayString(_unref(quote).address.zip), 1)
                ])
              ]),
              _createElementVNode("tr", null, [
                _hoisted_74,
                _createElementVNode("td", _hoisted_75, [
                  (_unref(quote).checkout.useSameAddressForMailing)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode(" Same as property address ")
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode(_toDisplayString(_unref(quote).checkout.mailingAddress.streetNumber) + " " + _toDisplayString(_unref(quote).checkout.mailingAddress.address), 1),
                        _hoisted_76,
                        _createTextVNode(" " + _toDisplayString(_unref(quote).checkout.mailingAddress.city) + " " + _toDisplayString(_unref(quote).checkout.mailingAddress.state.title) + " " + _toDisplayString(_unref(quote).checkout.mailingAddress.zip), 1)
                      ], 64))
                ])
              ]),
              _createElementVNode("tr", null, [
                _hoisted_77,
                _createElementVNode("td", _hoisted_78, [
                  _createTextVNode(_toDisplayString(_unref(quote).checkout.schoolName), 1),
                  _hoisted_79,
                  _createTextVNode(" " + _toDisplayString(_unref(quote).checkout.schoolCity), 1)
                ])
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_80, [
        _createElementVNode("div", _hoisted_81, [
          _createElementVNode("h4", null, [
            _createTextVNode(" Payment Method "),
            _createElementVNode("a", {
              href: "",
              class: "edit",
              onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (quoteCheckoutPayment()), ["prevent"]))
            }, "Edit")
          ]),
          _createElementVNode("table", _hoisted_82, [
            _createElementVNode("tbody", null, [
              _createElementVNode("tr", null, [
                _hoisted_83,
                _createElementVNode("td", _hoisted_84, [
                  (_unref(quote).checkout.paymentMethod.creditCard)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode(" Credit / Debit Card ")
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode(" Bank Account ")
                      ], 64))
                ])
              ]),
              (_unref(quote).checkout.paymentMethod.creditCard)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_85, [
                    _hoisted_86,
                    _createElementVNode("td", _hoisted_87, _toDisplayString(formatCardNumber(_unref(quote).checkout.paymentMethod.cardNumber)), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _hoisted_88,
          _createElementVNode("table", _hoisted_89, [
            _createElementVNode("tbody", null, [
              _createElementVNode("tr", null, [
                _hoisted_90,
                _createElementVNode("td", _hoisted_91, [
                  (_unref(quote).checkout.paymentMethod.billingAddressType === 1)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode(" Same as property address ")
                      ], 64))
                    : (_unref(quote).checkout.paymentMethod.billingAddressType === 2)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createTextVNode(" Same as mailing address ")
                        ], 64))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                          _createTextVNode(_toDisplayString(_unref(quote).checkout.paymentMethod.billingAddress.streetNumber) + " " + _toDisplayString(_unref(quote).checkout.paymentMethod.billingAddress.address), 1),
                          _hoisted_92,
                          _createTextVNode(" " + _toDisplayString(_unref(quote).checkout.paymentMethod.billingAddress.city) + " " + _toDisplayString(_unref(quote).checkout.paymentMethod.billingAddress.state.title) + " " + _toDisplayString(_unref(quote).checkout.paymentMethod.billingAddress.zip), 1)
                        ], 64))
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_93, [
          _hoisted_94,
          _createElementVNode("table", _hoisted_95, [
            _createElementVNode("tbody", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("td", _hoisted_96, [
                  _createTextVNode(" Assurant Renters Insurance Policy"),
                  _hoisted_97,
                  (_unref(quote).rentersInsurance.paymentOption != 2)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_98, "Your next payment of " + _toDisplayString(_unref(formatAmount)(
                        _unref(quote).rentersInsurance.installmentAmount +
                          _unref(quote).rentersInsurance.serviceFee
                      )) + " will be charged automatically on " + _toDisplayString(rentersNextPaymentDate.value) + " of the month.", 1))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("td", _hoisted_99, _toDisplayString(_unref(formatAmount)(_unref(quote).rentersInsurance.dueToday)), 1)
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("td", _hoisted_100, [
                  _createTextVNode(" NSSI Accidental Damage Personal Property Coverage Policy"),
                  _hoisted_101,
                  (_unref(quote).hasPersonalInsurance)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        (_unref(quote).personalInsurance.paymentOption != 2)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_102, "Your next payment of " + _toDisplayString(_unref(formatAmount)(
                          _unref(quote).personalInsurance.monthlyAmount + processingFee.value
                        )) + " will be charged automatically on " + _toDisplayString(nssiNextPaymentDate.value) + " of the month.", 1))
                          : _createCommentVNode("", true)
                      ], 64))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("td", _hoisted_103, _toDisplayString(_unref(quote).hasPersonalInsurance
                      ? _unref(formatAmount)(
                          _unref(quote).personalInsurance.dueToday + processingFee.value
                        )
                      : "N/A"), 1)
              ])
            ])
          ]),
          _hoisted_104,
          _hoisted_105,
          _hoisted_106,
          _createElementVNode("table", _hoisted_107, [
            _createElementVNode("tbody", null, [
              _createElementVNode("tr", null, [
                _hoisted_108,
                _createElementVNode("td", _hoisted_109, _toDisplayString(_unref(formatAmount)(quoteTotal.value)), 1)
              ])
            ])
          ]),
          _hoisted_110,
          _hoisted_111,
          _hoisted_112,
          _hoisted_113,
          _hoisted_114,
          _hoisted_115,
          _createElementVNode("p", _hoisted_116, [
            _createTextVNode(" By clicking \"Purchase Policy\", I acknowledge that I have read and understand the applicable "),
            _createElementVNode("a", {
              class: "javascriptlink",
              onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (showDisclosuresModal()), ["prevent"]))
            }, "notice of cancellation, "),
            _createTextVNode(" & "),
            _createElementVNode("a", {
              class: "javascriptlink",
              onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (showPaymentAuthorizationModal()), ["prevent"]))
            }, "recurring payment authorization. "),
            _createTextVNode(" I acknowledge that I am 18 years of age and have read and agree to the above terms. ")
          ])
        ])
      ]),
      _hoisted_117
    ]),
    _createElementVNode("div", _hoisted_118, [
      _createElementVNode("button", {
        disabled: issuingPolicies.value,
        onClick: _cache[5] || (_cache[5] = ($event: any) => (goToPage('quote-done')))
      }, " Purchase Policy ", 8, _hoisted_119)
    ]),
    _hoisted_120,
    _hoisted_121,
    _hoisted_122,
    _hoisted_123,
    _createVNode(BaseModal, { name: "DisclosuresModal" }, {
      default: _withCtx(() => [
        _createVNode(DisclosuresModal)
      ]),
      _: 1
    }),
    _createVNode(BaseModal, { name: "PaymentAuthorizationModal" }, {
      default: _withCtx(() => [
        _createVNode(PaymentAuthorizationModal)
      ]),
      _: 1
    })
  ]))
}
}

})